var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabletLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9A",
    d: "M92.566,22.081c0-1.676-1.358-3.035-3.035-3.035H10.469c-1.676,0-3.035,1.359-3.035,3.035 c0,0.043,0.011,0.084,0.013,0.127H7.434v55.838h0.013c0.068,1.616,1.389,2.908,3.022,2.908h79.062c1.633,0,2.954-1.292,3.022-2.908 h0.013V22.208h-0.013C92.555,22.164,92.566,22.124,92.566,22.081z M82.609,70.997H17.391V29.003h65.219V70.997z M87.587,52.611 c-1.372,0-2.484-1.112-2.484-2.484c0-1.372,1.112-2.484,2.484-2.484c1.372,0,2.485,1.112,2.485,2.484 C90.072,51.499,88.959,52.611,87.587,52.611z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletLandscape);
export default __webpack_public_path__ + "static/media/tablet-landscape.f041f9c31922fc580f2757b8920fa180.svg";
export { ForwardRef as ReactComponent };